import ThreeBackground from './ThreeBackground';

const motionSafe =
  'opacity-0 motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:animate-none';

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  backgroundImage,
  titleClassName,
  subtitleClassName,
  children,
}) {
  const titleClasses = titleClassName
    ? `mt-4 text-balance text-white ${titleClassName} ${motionSafe} animate-fade-in-up [animation-delay:120ms]`
    : `mt-4 text-balance font-sans text-4xl font-bold tracking-tight text-white sm:text-5xl ${motionSafe} animate-fade-in-up [animation-delay:120ms]`;

  const subtitleClasses =
    subtitleClassName ??
    `mx-auto mt-4 max-w-2xl text-center text-sm font-light leading-relaxed text-white/85 sm:text-base ${motionSafe} animate-fade-in-up [animation-delay:240ms]`;

  return (
    <section className="relative overflow-hidden pt-28">
      <div
        className="absolute inset-0 bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: 'center center',
        }}
        aria-hidden
      />
      <div className="absolute inset-0 opacity-40 mix-blend-screen" aria-hidden>
        <ThreeBackground />
      </div>
      <div className="absolute inset-0 bg-navy-950/65" aria-hidden />

      <div className="relative mx-auto flex min-h-[260px] max-w-7xl items-center px-4 py-16 text-center sm:min-h-[300px] sm:px-6 lg:min-h-[340px] lg:px-8">
        <div className="mx-auto w-full">
          {eyebrow ? (
            <p className={`text-xs font-semibold tracking-[0.25em] text-gold ${motionSafe} animate-fade-in-up`}>
              {eyebrow}
            </p>
          ) : null}
          <h1 className={titleClasses}>{title}</h1>
          {subtitle ? <p className={subtitleClasses}>{subtitle}</p> : null}
          {children}
        </div>
      </div>
    </section>
  );
}

